import { React,useEffect,useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './menuExtrato.css';
import api from '../../services/api';
import Loading from "../Layout/Loading";

function MenuExtrato(){

    //#region consts

    const navigate = useNavigate();

    const location = useLocation();

    const { ID_EMPRESA } = location.state;

    const [showLoading, setShowLoading] = useState(false);
    const [dadosGerais, setDadosGerais] = useState({});

    
    
    /* Constantes para controlar o foco do mouse nos botões */
    const [isHoverNovoBoleto, setIsHoverNovoBoleto] = useState(false);
    const [isHoverVoltar, setIsHoverVoltar] = useState(false);

    //#endregion



    //#region handle mouse
    const handleMouseEnterNovoBoleto = () => {
        setIsHoverNovoBoleto(true);
    };

    const handleMouseLeaveNovoBoleto = () => {
        setIsHoverNovoBoleto(false);
    };

    const handleMouseEnterVoltar = () => {
        setIsHoverVoltar(true);
    };

    const handleMouseLeaveVoltar = () => {
        setIsHoverVoltar(false);
    };
    //#endregion



    //#region functions

    function Voltar(){
        navigate("/taxacusteio");
    }

    function NovoBoleto(){
        
        navigate("/novoboleto", { state: dadosGerais });

    }

    //#endregion



    //#region useEffect

    useEffect(() => {

        setShowLoading(true);

        setTimeout(() => {
            
            api.get("cadastro/dadostaxacusteiodestaempresa", {
                                                                params: {
                                                                    idempresa: ID_EMPRESA
                                                                }
                                                            })    
                .then((resp) => {
                    
                    setDadosGerais(resp.data);
                    setShowLoading(false);

                })
                .catch((err) => {
                    if(err.response.data.RESULT){
                        alert(err.response.data.RESULT);
                    }else{
                        alert(err.response.data);
                    }
                    setShowLoading(false);
                });
        }, 500);

    }, []);

    //#endregion


    //#region html

    return(
        
            <div className="_cnpjcpf-container_" 
                style={{padding:"10px 10px 0 10px",
                        textAlign:'center',
                        backgroundColor:'#fff',
                        height:'89.9vh',
                        overflow:'auto'}}>

                {!showLoading ? (

                    <>

                        {
                            
                            (Object.keys(dadosGerais).length > 0) ? (
                            
                                <div className="form-control">

                                    <div className="cnpjcpf-content-container" 
                                            style={{backgroundColor:'#fff',
                                                    marginBottom:'0.5rem'}}>

                                        <div style={{fontSize:'24px',
                                                        color:'#423c89',
                                                        backgroundColor:'#fff',
                                                        marginBottom:'0.5rem'}}>
                                            <h3>Menu - Taxa de custeio</h3>
                                        </div>

                                        <div style={{fontSize:'16px',
                                                     backgroundColor:'#fff',
                                                     marginBottom:'0.5rem'}}>
                                            
                                            {/* Dados da empresa */}
                                            <div style={{backgroundColor:'gray', 
                                                            width:'100%',
                                                            margin:'auto',
                                                            color:'white',
                                                            borderRadius:'0.5rem'}}>
                                                Dados da empresa
                                            </div>

                                            {/* CNPJ */}
                                            <div style={{textAlign:'left'}}>
                                                <span style={{fontWeight:'bold'}}>CNPJ:</span>
                                                <span style={{marginLeft:'0.5rem'}}>{dadosGerais.EMPRESA.CNPJ}</span>
                                            </div>

                                            {/* NOME_FANTASIA */}
                                            <div style={{textAlign:'left'}}>
                                                <span style={{fontWeight:'bold'}}>Nome Fantasia:</span>
                                                <span style={{marginLeft:'0.5rem'}}>{dadosGerais.EMPRESA.NOME_FANTASIA}</span>
                                            </div>

                                            {/* RAZAO_SOCIAL */}
                                            <div style={{textAlign:'left'}}>
                                                <span style={{fontWeight:'bold'}}>Razão social:</span>
                                                <span style={{marginLeft:'0.5rem'}}>{dadosGerais.EMPRESA.RAZAO_SOCIAL}</span>
                                            </div>

                                            
                                            {/* Dados da CCT vigente */}
                                            <div style={{backgroundColor:'gray', 
                                                            width:'100%',
                                                            margin:'auto',
                                                            color:'white',
                                                            borderRadius:'0.5rem',
                                                            marginTop:'1rem'}}>
                                                Dados da CCT vigente
                                            </div>

                                            {/* Descrição */}
                                            <div style={{textAlign:'left'}}>
                                                <span style={{fontWeight:'bold'}}>Descrição:</span>
                                                <span style={{marginLeft:'0.5rem'}}>{dadosGerais.PARAMETRO.DESCRICAO}</span>
                                            </div>

                                            {/* Período */}
                                            <div style={{textAlign:'left'}}>
                                                <span style={{fontWeight:'bold'}}>Vigência:</span>
                                                <span style={{marginLeft:'0.5rem'}}>{`${dadosGerais.PARAMETRO.DATA_INICIAL_CCT} à ${dadosGerais.PARAMETRO.DATA_FINAL_CCT}`}</span>
                                            </div>

                                            {/* Duração */}
                                            <div style={{textAlign:'left'}}>
                                                <span style={{fontWeight:'bold'}}>Duração:</span>
                                                <span style={{marginLeft:'0.5rem'}}>{`${dadosGerais.PARAMETRO.QTDE_MESES_VIGENCIA} meses`}</span>
                                            </div>


                                            {/* Caso exista histórico de guias assistencias pagas com RE informadas... */}
                                            {
                                                (dadosGerais.HISTORICO_PAGAMENTOS_COM_RE.length > 0) ? (

                                                    <>
                                                        <div style={{backgroundColor:'#F5A402', 
                                                                    width:'100%',
                                                                    margin:'auto',
                                                                    color:'white',
                                                                    borderRadius:'0.5rem',
                                                                    marginTop:'1rem'}}>
                                                            Histórico - Últimas guias pagas com relação de funcionários informada
                                                        </div>

                                                        {
                                                            dadosGerais.HISTORICO_PAGAMENTOS_COM_RE.map((item) => {
                                                                return (
                                                                    <div key={item.NUM_LISTA}
                                                                            style={{backgroundColor:'#80B4F0', // #8BA0E6 #2957A4 #80B4F0
                                                                                    margin:'0.3rem 0.3rem 0.3rem 0.3rem',
                                                                                    padding:'0.2rem 0.2rem 0.2rem 0.2rem',
                                                                                    borderRadius: '0.5rem'}}>
                                                                    
                                                                        {/* Nº guia */}
                                                                        <div style={{textAlign:'left'}}>
                                                                            <span style={{fontWeight:'bold'}}>Nº Guia:</span>
                                                                            <span style={{marginLeft:'0.5rem'}}>{item.ID_GUIA}</span>
                                                                        </div>
                                                                    
                                                                        {/* Tipo guia */}
                                                                        <div style={{textAlign:'left'}}>
                                                                            <span style={{fontWeight:'bold'}}>Guia:</span>
                                                                            <span style={{marginLeft:'0.5rem'}}>{item.GUIA}</span>
                                                                        </div>
                                                                    
                                                                        {/* Data pagamento */}
                                                                        <div style={{textAlign:'left'}}>
                                                                            <span style={{fontWeight:'bold'}}>Data pagamento:</span>
                                                                            <span style={{marginLeft:'0.5rem'}}>{item.DATA_PAGAMENTO}</span>
                                                                        </div>
                                                                    
                                                                        {/* Qtde funcionários na RE */}
                                                                        <div style={{textAlign:'left',
                                                                                        height:'30px',
                                                                                        alignContent:'center'}}>
                                                                            <span style={{fontWeight:'bold'}}>Qtde contribuintes informados:</span>
                                                                            <span style={{marginLeft:'0.5rem',
                                                                                            color:'red',
                                                                                            fontWeight:'bold'}}>
                                                                                            {item.QT_CONTRIBUINTES}
                                                                            </span>
                                                                        </div>

                                                                    </div>
                                                                );
                                                            })
                                                        }
                                                    </>

                                                    
                                                ) : null
                                            }


                                            {/* DIV dos botões */}
                                            <div style={{width:'100%'}}>

                                                {/* Voltar */}
                                                <div style={{backgroundColor: isHoverVoltar ? '#2957A4' : '#fff',
                                                            width:'150px', display:'inline-block',
                                                            height:'28px',
                                                            alignContent: 'center',
                                                            cursor:'pointer',
                                                            margin:'auto',
                                                            color: isHoverVoltar ? '#fff' : 'black',
                                                            marginRight:'5px',
                                                            borderRadius:'0.5rem',
                                                            borderWidth:'0.2rem',
                                                            borderStyle:'solid',
                                                            borderColor:'#2957A4',
                                                            marginTop:'2rem',
                                                            marginBottom:'2rem'}}
                                                    onMouseEnter={handleMouseEnterVoltar}
                                                    onMouseLeave={handleMouseLeaveVoltar}
                                                    onClick={Voltar}>
                                                    Voltar
                                                </div>

                                                {/* Novo boleto */}
                                                <div style={{backgroundColor: isHoverNovoBoleto ? '#0033EA' : '#2957A4',
                                                            width:'150px', display:'inline-block',
                                                            height:'28px',
                                                            alignContent: 'center',
                                                            cursor:'pointer',
                                                            margin:'auto',
                                                            color:'white',
                                                            borderRadius:'0.5rem',
                                                            borderWidth:'0.2rem',
                                                            borderStyle:'solid',
                                                            borderColor:isHoverNovoBoleto ? '#0033EA' : '#2957A4', 
                                                            marginLeft:'5px',
                                                            marginTop:'2rem',
                                                            marginBottom:'2rem'}}
                                                    onMouseEnter={handleMouseEnterNovoBoleto}
                                                    onMouseLeave={handleMouseLeaveNovoBoleto}
                                                    onClick={NovoBoleto}>
                                                    Emitir novo boleto
                                                </div>
                                            </div>


                                            {/* Resumo dos pagamentos */}
                                            <div style={{backgroundColor:'gray', 
                                                         width:'100%',
                                                         margin:'auto',
                                                         color:'white',
                                                         borderRadius:'0.5rem',
                                                         marginTop:'1rem'}}>
                                                Resumo dos pagamentos
                                            </div>

                                            {/* Qtde total */}
                                            <div style={{textAlign:'left'}}>
                                                <span style={{fontWeight:'bold'}}>Total de meses:</span>
                                                <span style={{marginLeft:'0.5rem'}}>{dadosGerais.RESUMO_PAGAMENTOS.QT_MESES_TOTAL}</span>
                                            </div>

                                            {/* Qtde pagos */}
                                            <div style={{textAlign:'left'}}>
                                            <span style={{fontWeight:'bold'}}>Total de meses pagos:</span>
                                                <span style={{marginLeft:'0.5rem'}}>{dadosGerais.RESUMO_PAGAMENTOS.QT_MESES_PAGOS}</span>
                                            </div>

                                            {/* Qtde em aberto */}
                                            <div style={{textAlign:'left'}}>
                                            <span style={{fontWeight:'bold'}}>Total de meses em aberto:</span>
                                                <span style={{marginLeft:'0.5rem'}}>{dadosGerais.RESUMO_PAGAMENTOS.QT_MESES_EM_ABERTO}</span>
                                            </div>

                                            
                                            {/* Extrato dos pagamentos */}
                                            <div style={{backgroundColor:'gray', 
                                                         width:'100%',
                                                         margin:'auto',
                                                         color:'white',
                                                         borderRadius:'0.5rem',
                                                         marginTop:'1rem'}}>
                                                Extrato dos pagamentos
                                            </div>

                                            {/* Loop extrato */}                                                
                                            {
                                                dadosGerais.EXTRATO_PAGAMENTOS.map((item) => {
                                                    return (

                                                        <div key={item.REFERENCIA}
                                                                style={{backgroundColor:'silver', 
                                                                width:'100%',
                                                                margin:'auto',
                                                                height: '50px',
                                                                borderRadius:'0.5rem',
                                                                marginTop:'1rem',
                                                                textAlign:'left',
                                                                alignContent: 'center'}}>


                                                        
                                                            <div>
                                                                <span style={{marginLeft:'0.3rem',fontWeight:'bold'}}>Parcela:</span>
                                                                <span style={{marginLeft:'0.3rem',color:'blue'}}>{item.PARCELA}</span>
                                                                
                                                                <span style={{marginLeft:'0.3rem',fontWeight:'bold'}}>Referência:</span>
                                                                <span style={{marginLeft:'0.3rem',color:'blue'}}>{item.REFERENCIA_STR}</span>
                                                            </div>
                                                            
                                                            <div>
                                                                <span style={{marginLeft:'0.3rem',fontWeight:'bold'}}>Vencimento:</span>
                                                                <span style={{marginLeft:'0.3rem',color:'blue'}}>{item.DATA_VENCIMENTO}</span>
                                                                
                                                                <span style={{marginLeft:'0.3rem',fontWeight:'bold'}}>Status:</span>
                                                                {
                                                                    (item.STATUS === 'A') ? (

                                                                        <div style={{marginLeft:'0.3rem',
                                                                                    display:'inline-block',
                                                                                    color:'white',
                                                                                    backgroundColor:'green',
                                                                                    width:'75px',
                                                                                    textAlign:'center',
                                                                                    marginBottom: '0.1rem',
                                                                                    borderRadius:'0.5rem'}}>
                                                                            ABERTO
                                                                        </div>
                                                                    ) : (

                                                                        <div style={{marginLeft:'0.3rem',
                                                                                    display:'inline-block',
                                                                                    color:'white',
                                                                                    backgroundColor:'blue',
                                                                                    width:'75px',
                                                                                    textAlign:'center',
                                                                                    marginBottom: '0.1rem',
                                                                                    borderRadius:'0.5rem'}}>
                                                                            PAGO
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>

                                                        </div>
                                                    );
                                                })
                                            }



                                            {/* DIV dos botões */}
                                            <div style={{width:'100%'}}>

                                                {/* Voltar */}
                                                <div style={{backgroundColor: isHoverVoltar ? '#2957A4' : '#fff',
                                                            width:'150px', display:'inline-block',
                                                            height:'28px',
                                                            alignContent: 'center',
                                                            cursor:'pointer',
                                                            margin:'auto',
                                                            color: isHoverVoltar ? '#fff' : 'black',
                                                            marginRight:'5px',
                                                            borderRadius:'0.5rem',
                                                            borderWidth:'0.2rem',
                                                            borderStyle:'solid',
                                                            borderColor:'#2957A4',
                                                            marginTop:'2rem',
                                                            marginBottom:'2rem'}}
                                                    onMouseEnter={handleMouseEnterVoltar}
                                                    onMouseLeave={handleMouseLeaveVoltar}
                                                    onClick={Voltar}>
                                                    Voltar
                                                </div>

                                                {/* Novo boleto */}
                                                <div style={{backgroundColor: isHoverNovoBoleto ? '#0033EA' : '#2957A4',
                                                            width:'150px', display:'inline-block',
                                                            height:'28px',
                                                            alignContent: 'center',
                                                            cursor:'pointer',
                                                            margin:'auto',
                                                            color:'white',
                                                            borderRadius:'0.5rem',
                                                            borderWidth:'0.2rem',
                                                            borderStyle:'solid',
                                                            borderColor:isHoverNovoBoleto ? '#0033EA' : '#2957A4', 
                                                            marginLeft:'5px',
                                                            marginTop:'2rem',
                                                            marginBottom:'2rem'}}
                                                    onMouseEnter={handleMouseEnterNovoBoleto}
                                                    onMouseLeave={handleMouseLeaveNovoBoleto}
                                                    onClick={NovoBoleto}>
                                                    Emitir novo boleto
                                                </div>
                                            </div>



                                        </div>

                                        
                                    </div>
                                </div>

                            ) : null
                        }

                    </>


                ) :  <Loading />}

            </div>
    )

    //#endregion

}

export default MenuExtrato;
